import { Injectable } from '@angular/core';
// import { HttpClientService } from '../http-client';
// import { Store } from 'store';
import { map, catchError, distinctUntilChanged, switchMap, debounceTime } from 'rxjs/operators';
import { Course } from '../models/course.model';
import { Exercise } from '../models/exercise.model';
import { Note } from '../models/note.model';
import { User } from '../models/user.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { Evaluation } from '../models/evaluation.model';
// import { ScoreFaqModalV2Component } from '../shared/score-faq-modal-v2/score-faq-modal-v2.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from 'src/app/core/store/store';
import { HttpClientService } from 'src/app/core/http/http-client';
// declare var amplitude;
declare var ga;

@Injectable({
  providedIn: 'root'
})
export class CourseService {
  private getHeaderHeight = new Subject<number>()
  public getHeaderHeight$ = this.getHeaderHeight.asObservable()
  private time = new BehaviorSubject<number>(0);
  public time$ = this.time.asObservable().pipe(distinctUntilChanged())
  private currentPlayedItem = new Subject<string>();
  public currentItem = '';
  public currentPlayedItem$ = this.currentPlayedItem.asObservable().pipe(distinctUntilChanged())
  private notes = new BehaviorSubject<Note[]>([]);
  public notes$ = this.notes.asObservable().pipe(distinctUntilChanged())
  constructor(private http: HttpClientService, private store: Store, private modalService: NgbModal) { }
  setcurrentPlayedItem(item: string) {
    this.currentItem = item;
    this.currentPlayedItem.next(item);
  }
  set headerHeight(val) {
    this.getHeaderHeight.next(val)
  }
  setCurrentPlayerTime(time: number) {
    this.time.next(time);
  }
  getCourses(page: number = 0, limit: number = 3, project: string = '', isInterestCount: boolean = false, showAllCourse: boolean = false, showAllCourseOnLearn: boolean = false, showCustomCourse: boolean = false) {

    return this.http.get<{ data: Course, result: number, msg: string }>(`courses?page=${page}&limit=${limit}&project=${project}&isInterestCount=${isInterestCount}&showAllCourse=${showAllCourse}&showAllCourseOnLearn=${showAllCourseOnLearn}&showCustomCourse=${showCustomCourse}`).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        return [err];
      })
    )
  }

  getPopularCourses() {
    return this.http.get<{ data: Course[], result: number, msg: string }>(`courses?isPopular=true`)
  }

  getExerciseGraph(templateName) {
    return this.http.get<{ data: any, result: number, msg: string }>(`courses/exercise/graph?templateName=${templateName}`).pipe(map(res => {
      if (res && res.data) {
        return res.data
      }
    }));
  }
  getCourse(courseName: string) {
    return this.http.get<{ data: Course, result: number, msg: string }>(`ipj/course/${courseName}`).pipe(
      map(res => {
        if (Object.keys(res.data).length > 0) {
          this.store.set(`course`, res.data);
          return res.data;
        }
        else return null;
      })
    )
  }

  getCourseFeedback(courseId) {
    this.http.get(`users/course-feedback?courseId=${courseId}`).subscribe((res) => {
      if (res['data']) {
        let feedbackIdMap = {};
        res['data'].forEach(feedback => {
          if (feedback.videoId) {
            feedbackIdMap[feedback.videoId] = feedback;
          } else {
            feedbackIdMap[feedback.questionId] = feedback;
          }
        });
        this.store.set('courseFeedback', feedbackIdMap);
      }
    });
  }

  validateUrl(uId) {

    return this.http.get<{ data: Object, result: number, msg: string }>(`users/course-partner-info?uniqueId=${uId}`).pipe(map(res => {
      if (res && res.data) {
        return res.data
      }
    }));
  }
  getCertificate(uId) {

    return this.http.get<{ data: Object, result: number, msg: string }>(`users/certificate/${uId}`).pipe(map(res => {
      if (res && res.data) {
        return res.data
      }
    }));
  }

  updateProgress(pactId: string, courseId: string, contentId: string, contentCompleted: boolean, isexercise?: boolean, answers?: any, timeSpent?: any, isActivity?) {
  
    if (isexercise) {
      return this.http.put<{ data: User, result: number, msg: string }>(`ipj/user-progress/course`, { programActivationId: pactId, courseId: courseId, exerciseId: contentId, contentCompleted: contentCompleted, answers: answers, timeSpent: timeSpent }).pipe(map(res => {
        // this.store.set(`user`, res.data);
        this.store.set('currentUserCourse', res.data);
        return res.data;
      }));
    } else if (isActivity) {
      return this.http.put<{ data: User, result: number, msg: string }>(`ipj/user-progress/course`, { programActivationId: pactId, courseId: courseId, activityId: contentId, contentCompleted: contentCompleted, answers: answers }).pipe(map(res => {
        // this.store.set(`user`, res.data);
        this.store.set('currentUserCourse', res.data);
        return res.data;
      }));
    } else {
      return this.http.put<{ data: User, result: number, msg: string }>(`ipj/user-progress/course`, { programActivationId: pactId, courseId: courseId, contentId: contentId, contentCompleted: contentCompleted }).pipe(map(res => {
        // commented in IPJ
        //if (contentCompleted) {
        //   ga('send', 'event', {
        //     eventCategory: 'Learner Player',
        //     eventAction: 'Completed a video',
        //     // eventLabel: `course: ${this.courseTitle}, exercise: ${this.exerciseData.title}`
          // });
        // }
        // this.store.set(`user`, res.data);
        this.store.set('currentUserCourse', res.data);
        return res.data;
      }));
    }
  }
  markCourseCompleted(courseId) {
    return this.http.put<{ data: User, result: number, msg: string }>(`users/mark-course-completed`, { courseId: courseId }).pipe(map(res => {
      if (res && res.data) {
        // this.store.set(`user`, res.data);
        this.store.set('currentUserCourse', res.data);
      }
      return res.data;
    }));
  }
  updateVideoViewedTime(data) {
    return this.http.put<{ data: User, result: number, msg: string }>(`ipj/user-progress/save-exercise-and-video-progress`, data).pipe(debounceTime(2000), map(res => {
      // this.store.set(`user`, res.data);
      this.store.set('currentUserCourse', res.data);
      return res.data;
    }));
  }
  generateCertificate(courseId) {
    return this.http.put<{ data: User, result: number, msg: string }>(`users/generate-course-completion-certificate`, { courseId }).pipe(map(res => {
      // this.store.set(`user`, res.data);
      this.store.set('currentUserCourse', res.data);
      return res.data;
    }));
  }

  toggleBookmark(courseId: string, contentId: string, moduleNumber: number, moduleName: string,  programActivationId: string) {
    return this.http.post<{ data: User, result: number, msg: string }>(`ipj/notes-and-bookmarks/bookmark/toggle`, { courseId: courseId, contentId: contentId, moduleNumber: moduleNumber, moduleName: moduleName,  programActivationId: programActivationId}).pipe(map(res => {
      // this.store.set('currentUserCourse', res.data);
      // if (courseTitle) {
        /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
        amplitude.getInstance().setUserId(res.data.email);
        amplitude.getInstance().logEvent('Learner player add bookmark', { 'courseId': courseId, 'contentId': contentId, 'moduleName': moduleName, 'moduleNumber': moduleNumber, 'Course Title': courseTitle }); */
      // }
      
      return res;
    }
    ))
  }

  getBookmarks(courseId?: string) {
    if (courseId) {
      return this.http.get<{
        data: {
          courseLogo: string, courseId: string, courseTitle: string, moduleNumber: string, contents: { _id: string, duration: number, mediaType: string, title: string }[]
        }[], result: number, msg: string
      }>(`users/bookmark/${courseId}`).pipe(
        map(res => res.data)
      );
    } else {
      return this.http.get<{
        data: {
          courseLogo: string, courseId: string, courseTitle: string, moduleNumber: string, contents: { _id: string, duration: number, mediaType: string, title: string }[]
        }[], result: number, msg: string
      }>(`users/bookmark`).pipe(
        map(res => res.data)
      );
    }
  }

  setNotes(item: Note[] | Note, action: 'add' | 'delete' | 'update' | 'get') {

    if (action == 'get') return this.notes.next(item as Note[]);
    if (action == 'add') {
      return this.notes.next([...this.notes.value, item as Note]);
    }
    if (action == 'delete') {
      let index = this.notes.value.findIndex(n => n._id == (item as Note)._id);
      let notes = [...this.notes.value];
      notes.splice(index, 1);
      return this.notes.next(notes);
    }
    if (action == 'update') {
      let index = this.notes.value.findIndex(n => n._id == (item as Note)._id);
      let notes = [...this.notes.value];
      notes[index] = item as Note;
      return this.notes.next(notes);
    }
  }

  getNotes({ courseId = '', contentId = '', isGrouped = false, moduleName = '', programActivationId}) {
    let notes$ = this.http.get<{ data: Note[], result: number, msg: string }>(`ipj/notes-and-bookmarks?courseId=${courseId}&contentId=${contentId}&isGrouped=${isGrouped}&moduleName=${moduleName}&programActivationId=${programActivationId}&type='NOTES'`).pipe(
      map(res => {
        return res.data
      })
    )
    if (moduleName === '') return notes$
    else notes$.subscribe(notes => {
      this.setNotes(notes, 'get')
    });
  }

  getCourseNotes({ courseId = '', isGrouped = false, programActivationId, type = 'NOTES' }) {
    let notes$ = this.http.get<{ data: Note[], result: number, msg: string }>(`ipj/notes-and-bookmarks?courseId=${courseId}&isGrouped=${isGrouped}&programActivationId=${programActivationId}&type=${type}`).pipe(
      map(res => {
        return res.data
      })
    )
    notes$.subscribe(notes => {
      this.setNotes(notes, 'get')
    })
  }

  getAllNotes() {
    return this.http.get<{ data: Note[], result: number, msg: string }>(`notes`).pipe(
      map(res => res.data)
    );
  }
  addNote(course: string, content: string, description: string, recordedTime: number, videoIndex: number = 0, moduleNumber: any, moduleName: string, programActivationId: string, type = 'NOTES') {
  //  return this.http.post<{ data: Note, result: number, msg: string }>(`ipj/notes-and-bookmarks/notes`, { course, content, description, recordedTime, videoIndex, moduleNumber: moduleNumber.trim(), moduleName,  programActivationId, type });
   return this.http.post<{ data: Note, result: number, msg: string }>(`ipj/notes-and-bookmarks/notes`, { course, content, description, recordedTime, videoIndex, moduleNumber, moduleName,  programActivationId, type });
  
  }
  updateNote(noteId: string, description: string) {
    this.http.put<{ data: Note, result: number, msg: string }>(`ipj/notes-and-bookmarks/notes/${noteId}`, { description }).subscribe(
      res => {
        this.setNotes(res.data, 'update');
        
        // update notes text in player
        this.getCourseNotes({ courseId: res.data['course'], isGrouped: true, programActivationId: res.data['programActivationId'], type: 'NOTES' })
      }
    )
  }
  deleteNote(noteId: string) {
    return this.http.remove<{ data: Note, result: number, msg: string }>(`ipj/notes-and-bookmarks/notes/${noteId}`);
  }

  getExercise(id: string) {
    return this.http.get<{ data: Exercise, result: number, msg: string }>(`ipj/exercise/by/${id}`).pipe(
      map(res => {
        return res.data;
      })
    )
  }

  evaluateCourse(id: string) {
    return this.http.get<{ data: Evaluation, result: number, msg: string }>(`users/evaluate/${id}`).pipe(
      map(res => {
        return res.data;
      })
    )
  }
  evaluateAllCourse() {
    return this.http.get<{ data: Evaluation[], result: number, msg: string }>(`users/evaluate/`).pipe(
      map(res => {
        return res.data;
      })
    );
  }

  getInterestCount(courseName: string) {
    return this.http.get<{ data: { courseTotalUser: number, courseSelected: number }, result: number, msg: string }>(`interestedcourse/${courseName}`).pipe(
      map(res => {
        return res.data;
      })
    )
  }
  setInterestCount(courseId: string) {
    return this.http.post<{ data: { courseTotalUser: number, courseSelected: number }, result: number, msg: string }>(`interestedcourse`, { courseId }).pipe(
      map(res => {
        return res;
      })
    )
  }
  contactus(data) {
    return this.http.post<{ data: { name: string, businessName: string, designationName: string, email: string, phone: string, message: string, type: string, "g-recaptcha-response" : string } }>(`utils/contact-us`, { name: data.name, businessName: data.businessName, designationName: data.designationName, email: data.email, phone: data.phone, message: data.phone, type: data.type, "g-recaptcha-response" : data["g-recaptcha-response"] }).pipe(
      map(res => {
        return res;
      })
    )
  }
  contactusPage(data) {
    return this.http.post<{ data: { name: string, email: string, message: string, queryType: string, phoneNumber: string, "g-recaptcha-response" : string } }>(`utils/contact-us/info`, { name: data.name, email: data.email, message: data.msg, queryType: data.queryType, phoneNumber: data.phone, type: "CONTACT-US", "g-recaptcha-response" : data["g-recaptcha-response"] }).pipe(
      map(res => {
        return res;
      })
    )
  }

  getAllFaculty() {
    return this.http.get<{ data: any, result: number, msg: string }>(`courses/faculty/info`).pipe(
      map(res => {
        return res.data;
      })
    )
  }
  getViaQuestions() {
    return this.http.get<{ data: any, result: number, msg: string }>(`via/getQuestions`).pipe(
      map(res => {
        return res.data;
      })
    )
  }
  submitViaAnswer(answers: any[]) {
    return this.http.post<{ data: any, result: number, msg: string }>(`via/submitAnswer`, { answers }).pipe(
      map(res => {
        return res;
      })
    )
  }

  courseFeedbackForm(data, id) {
    return this.http.post<{ data: any, result: number, msg: string }>(`courses/completion-feedback/${id}`, { ...data }).pipe(
      map(res => {
        return res;
      })
    )
  }


  certificateQuery(data) {
    return this.http.post<{ data: any, result: number, msg: string }>(`users/certificate-change-request`, { ...data }).pipe(
      map(res => {
        return res;
      })
    )
  }

  openScoreFaqV2Modal(isV2=false) {
    // const modalRef = this.modalService.open(ScoreFaqModalV2Component, {
    //   windowClass: 'modal-cntrl modal-cntrl-lg'
    // });
    // if (isV2)
    //   modalRef.componentInstance.isV2Assessment = isV2;
  }

  getPurchasedBundle(email) {
    return this.http.post<{ data: any, result: number, msg: string }>('payment/purchasedbundle', {email: email}).pipe(map(res => {
      return res;
    }));
  }

  getCourseBookmarks({ courseId = '', programActivationId, type = 'BOOKMARKS' }) {
    return this.http.get<{ data: Note[], result: number, msg: string }>(`ipj/notes-and-bookmarks?courseId=${courseId}&programActivationId=${programActivationId}&type=${type}`).pipe(
      map(res => {
        return res.data;

      })
    )
  }

  getIpjCertificate(uId) {

    return this.http.get<{ data: Object, result: number, msg: string }>(`ipj/feedback-and-certificate/fetch-certificate/${uId}`).pipe(map(res => {
      if (res && res.data) {
        return res.data
      }
    }));
  }

}
